export default __webpack_public_path__ + "static/media/Mark-4-Suit-02.3c96f680.jpg";